import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { OrderLocation } from "../../orders.types";
import { requestGetOrdersLocations } from "./getOrdersLocations.request";

const useGetOrdersLocations = (
  options?: QueryOptions<OrderLocation[], ApiServiceError<ApiError>>
) => {
  const { data: locations = [], ...rest } = useQuery({
    queryKey: ["order", "admin", "locations"],
    queryFn: async () => await requestGetOrdersLocations(),
    onError: toastServerError,
    ...options
  });

  return { locations, ...rest };
};

export default useGetOrdersLocations;
